"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = require("prop-types");

var _css = _interopRequireDefault(require("@styled-system/css"));

var _styledSystem = require("styled-system");

var _system = _interopRequireDefault(require("../../utils/system"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var variantValues = {
  danger: 'danger',
  dark: 'dark',
  info: 'info',
  light: 'light',
  primary: 'primary',
  secondary: 'secondary',
  success: 'success',
  warning: 'warning'
};
var propsTypes = {
  /**
   * Set is a pill Badge.
   */
  pill: _propTypes.bool,

  /**
   * Control the variant color Badge.
   */
  variant: (0, _propTypes.oneOf)(Object.values(variantValues))
};
var defaultProps = {
  pill: false,
  variant: variantValues.primary
};
var Badge = (0, _system["default"])('span')({
  label: 'Badge'
}, (0, _css["default"])({
  borderRadius: 'md',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxSizing: 'border-box',
  fontSize: 'xs',
  lineHeight: '1',
  px: '2',
  py: '1',
  textDecoration: 'none',
  whiteSpace: 'nowrap'
}), (0, _styledSystem.variant)({
  scale: 'badge',
  variants: {
    danger: {
      bg: 'danger',
      color: 'white'
    },
    dark: {
      bg: 'gray.900',
      color: 'white'
    },
    info: {
      bg: 'info',
      color: 'white'
    },
    light: {
      bg: 'gray.50'
    },
    primary: {
      bg: 'primary.main',
      color: 'white'
    },
    secondary: {
      bg: 'secondary.main',
      color: 'white'
    },
    success: {
      bg: 'success',
      color: 'white'
    },
    warning: {
      bg: 'warning',
      color: 'text'
    }
  }
}), function (props) {
  return props.pill && (0, _css["default"])({
    borderRadius: 'full'
  });
});
Badge.displayName = 'Badge';
Badge.propTypes = propsTypes;
Badge.defaultProps = defaultProps;
var _default = Badge;
exports["default"] = _default;

//# sourceMappingURL=Badge.js.map